<!-- 底部组件 -->
<template>
  <div>
    <div class="list">
      <div class="name">
        <img src="../assets/addrshu.png">
        <span>{{msg.companyName}}</span>
      </div>
      <div class="tel">
        <img src="../assets/phone.png">
        <span>{{msg.telPhone}}</span>
      </div>
      <div class="addr">
        <img src="../assets/addr.png">
        <span>{{msg.address}}</span>
      </div>
    </div>
  </div>
</template>
    
<script>
  export default {
    name: 'addressOne',
    inject: ['reload'],
    props: ["msg"],
    data() {
      return {
        
      };
    },
    methods: {
      
    },
    mounted() {
    }
  };
</script>

<style scoped lang='scss'>
  .list{
    width: 404px;
    height: 205px;
    background: #FFFFFF;
    padding: 32px 35px;
    margin-bottom: 40px;

    & > div {
      display: flex;
      align-items: center;
      color: #333333;
      font-weight: 400;
      font-size: 14px;
      letter-spacing: 2px;

      &.name{
        font-size: 28px;
        margin-bottom: 20px;
        font-weight: 600;

        img{
          width: 9px;
          height: 26px;
          margin-right: 15px;
        }
      }

      &.tel{
        margin-bottom: 10px;

        img{
          width: 13px;
          height: 16px;
          margin-right: 10px;
        }
      }

      &.addr{
         align-items: flex-start;

        img{
          width: 13px;
          height: 16px;
          margin-right: 10px;
          margin-top: 3px;
        }
      }
    }
  }

  @media screen and ( max-width: 750px ) {
    .list{
      width: 6.8rem;
      height: 2.84rem;
      padding: 0.4rem 0.7rem;
      margin-bottom: 0.2rem;

      & > div {
        font-size: 0.24rem;
        letter-spacing: 0.02rem;

        &.name{
          font-size: 0.28rem;
          margin-bottom: 0.2rem;

          img{
            width: 0.13rem;
            height: 0.36rem;
            margin-right: 0.2rem;
          }
        }

        &.tel{
          margin-bottom: 0.2rem;

          img{
            width: 0.21rem;
            height: 0.27rem;
            margin-right: 0.1rem;
          }
        }

        &.addr{
          align-items: flex-start;

          img{
            width: 0.22rem;
            height: 0.28rem;
            margin-right: 0.1rem;
            margin-top: 0.03rem;
          }
        }
      }
    }
  }
</style>
    


// WEBPACK FOOTER //
// src/components/addressOne.vue